import React, { Suspense } from "react";
import FullScreenLoader from "../../components/loader/full-screen-loader";

const withSuspense = (Component: React.FunctionComponent<{}>) => (props: any) => {
    return (
        <Suspense fallback={<FullScreenLoader />}>
            <Component {...props} />
        </Suspense>
    );
};

export default withSuspense;
